import { management_api_host } from '@/utils/api';
import { getAuthorization } from '@/utils/authorization-util';

export type LocalIntentKind = 'command' | 'chat' | 'unknown';

export type LocalCommandName =
  | 'NAVIGATE_CHAT'
  | 'NAVIGATE_KNOWLEDGE'
  | 'NAVIGATE_PPT'
  | 'PLAY_PPT'
  | 'PAUSE_PLAYBACK'
  | 'RESUME_PLAYBACK'
  | 'STOP_PLAYBACK'
  | 'ENTER_PPT_QUESTION'
  | 'EXIT_PPT_QUESTION'
  | 'STOP_CONVERSATION'
  | 'SELECT_MODEL'
  | 'INTRODUCE_PRODUCT'
  | 'NAVIGATE_AND_INTRODUCE';

export type LocalIntentResponse = {
  ok?: boolean;
  kind: LocalIntentKind;
  confidence: number;
  command?: {
    name?: LocalCommandName | '';
    args?: Record<string, any>;
  };
  reply?: string;
};

// 全局保存当前请求
let currentIntentAbortController: AbortController | null = null;

export async function detectLocalIntent(params: {
  text: string;
  scene: {
    pageType?: string;
    inPptPlayback?: boolean;
    pptQuestionMode?: boolean;
    awaitingPptQuestion?: boolean;
    candidates?: Array<{ id: string; label: string }>;
  };
  api?: string;
  signal?: AbortSignal;
}): Promise<LocalIntentResponse> {
  const {
    text,
    scene,
    api = `${management_api_host}/assistant/local-intent`,
    signal,
  } = params;

  const token = getAuthorization();

  const resp = await fetch(api, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: token } : {}),
    },
    body: JSON.stringify({ text, scene }),
    signal,
  });

  if (!resp.ok) {
    throw new Error(`local intent http ${resp.status}`);
  }

  return resp.json();
}
